import http from '../../utils/fetch'
export default {
    selectCgShenpiPage(f){   //调价记录
        return http({
            url: '/api/swyl/v1/hetong/bscContractCgShenpi/selectCgShenpiPage',
            method: 'post',
            params: f
        });
    },
    selectListByInstid(f){   //调价记录
        return http({
            url: '/api/swyl/v1/hetong/bscContractCgShenpi/selectListByInstid',
            method: 'post',
            params: f
        });
    },
    cgBeiAnShenpiPass(f){   //调价记录备案审批
        return http({
            url: '/api/swyl/v1/hetong/bscContractCgShenpi/cgBeiAnShenpiPass',
            method: 'post',
            params: f
        });
    },
    getMaterialCostReduction(f){   //物料降成本
        return http({
            url: '/api/swyl/v1/dscCostReduction/statsMaterial',
            method: 'post',
            params: f
        });
    },
    getMaterialCostReductionNew(f){   //物料降成本
        return http({
            url: '/api/swyl/v1/dscCostReduction/statsMaterialNew',
            method: 'post',
            params: f
        });
    },
    getSupplierCostReduction(f){   //供应商降成本
        return http({
            url: '/api/swyl/v1/dscCostReduction/statsSupplier',
            method: 'post',
            params: f
        });
    },
    getListForOverseas(f){   //改制目录
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/selectListForOverseas',
            method: 'post',
            data: f
        });
    },
    selectListPage(f){   //改制目录
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/selectListPage',
            method: 'post',
            data: f
        });
    },
    insertReformCatalog(f){   //暂存改制目录
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/insert',
            method: 'post',
            data: f
        });
    },
    submitNew(f){   //提交改制目录
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/submitNew',
            method: 'post',
            data: f
        });
    },
    getReformCatalogDetail(f){   //改制目录详情
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/selectById',
            method: 'post',
            params: f
        });
    },
    reviewReformCatalog(f){   //改制目录详情
        return http({
            url: '/api/swyl/v1/reform/bscSpecificCatalogue/reviewReformCatalog',
            method: 'post',
            data: f
        });
    },

    contractCgBeiAnShenpi(f){   //调价记录
        return http({
            url: '/api/swyl/v1/hetong/bscContractCgShenpi/contractCgBeiAnShenpi',
            method: 'post',
            data: f
        });
    },


}